import styled from 'styled-components'
import { iPadDown } from '../../styles/mediaQueries'
import theme from '../../styles/theme'
import { DolaThemes } from '../../styles/types'

interface HeaderStyleProps {
  dolaTheme: DolaThemes
}

export const HeaderWrapper = styled.div<HeaderStyleProps>`
  background: ${({ dolaTheme }) => theme[dolaTheme].background};
  padding: 2.35vw;
  padding-bottom: 0;
  position: absolute;
  width: 100%;
  z-index: 100;

  ${iPadDown} {
    padding: 0 4.83vw;
    padding-top: 7.25vw;
    width: 100%;
  }
`

export const LineWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const RightItem = styled.div`
  display: flex;
  align-items: center;
`
